<template>
  <div class="basic-wysiwyg-entry v-application">
    <BasicWysiwyg
      :value="currentValue"
      :get-mentionables="getMentionableFunc"
      @input="setCurrentValue"
      :show-controls="toolbar"
      style="width: 100%"
    ></BasicWysiwyg>
    <input
      type="hidden"
      :id="inputId"
      :name="fieldName"
      :value="currentValue"
    />
  </div>
</template>

<script lang="ts">
/**
 * This is a BasicWysiwyg Entry Point to be used in Haml templates.
 */
import { computed, defineComponent, ref } from "vue"
import BasicWysiwyg from "components/Wysiwyg/BasicWysiwyg.vue"
import useMentionSearch from "concerns/useMentionSearch"
import { Group } from "suus-api"

export default defineComponent({
  name: "BasicWysiwygEntry",
  components: { BasicWysiwyg },
  props: {
    groupId: {
      type: Number,
      required: false,
    },
    value: {
      type: String,
      default: "",
    },
    fieldName: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    toolbar: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const _currentValue = ref(props.value)
    const currentValue = computed(() => _currentValue.value)
    const setCurrentValue = (val: string) => {
      _currentValue.value = val
    }

    const { mentionableFunction: getMentionableFunc } = useMentionSearch({
      group: { id: props.groupId } as Group,
    })

    console.log(props)

    return {
      currentValue,
      setCurrentValue,
      getMentionableFunc,
    }
  },
})
</script>

<style>
.basic-wysiwyg-entry .v-application--wrap {
  height: unset !important;
}
</style>
